<template>
  <div
    class="spotlight-card mb-0"
    :style="{ backgroundImage: `url(${require(`@/assets/dhs/${spotlight.internalName}-card.png`)})` }"
  >
    <router-link
      :aria-label="spotlight.name"
      class="text-white card-link d-flex"
      @click.native="trackClick($event, spotlight)"
      :to="`${getProductBasePath('spotlight')}/categories/${spotlight.category}/${spotlight.internalName}`"
    >
      <component :is="heroComponent" :spotlight="spotlight" />
    </router-link>
  </div>
</template>

<script>
import log from '@/services/log';
// Can't rely on global enumMixin here because it's not yet loaded when vue registers components
import SpotlightConstants from '@/utils/enums/spotlightConstants';

const SiriusXmVehicleProgram = () => import('@/modules/spotlight/components/dhs-heroes/SiriusXmVehicleProgram.vue');
const FirstCanadianBreakdown = () => import('@/modules/spotlight/components/dhs-heroes/FirstCanadianBreakdown.vue');
export default {
  name: 'SpotlightDHSHeroCard',
  props: {
    spotlight: {
      type: Object,
      required: true,
    },
  },
  components: {
    [SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM']]: SiriusXmVehicleProgram,
    [SpotlightConstants.internalNames.firstCanadian.BREAKDOWN]: FirstCanadianBreakdown,
  },
  computed: {
    heroComponent() {
      return `${this.spotlight.internalName}`;
    },
  },
  methods: {
    trackClick(e, spotlight) {
      // Analytics tracking
      const payload = {
        elementInteractedWith: `dhs.hero.${spotlight.internalName}`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.spotlight-card {
  border-radius: 6px;
  height: 125px;
  padding: 16px;
  top: 0;
  right: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center right;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    margin-bottom: 0.5rem;
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }

  @media (min-width: 575px) {
    height: 141px;
  }

  .card-link {
    height: 100%;
    font-size: 14px;

    &:hover {
      p {
        text-decoration: none;
      }

      .dhs-link-text {
        text-decoration: underline;
      }
    }
  }

  .dhs-text {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
